module.exports = __webpack_public_path__ + "img/efficiency.dad9c2c6.svg";